<template>
  <fade-transition origin="center" mode="out-in" :duration="250">
    <div v-if="smallScreen">
      <header
        class="header-global header"
        :class="{ 'navbar--hidden': !showNavbar }"
        v-if="showHeaderOnScreen"
      >
        <TopBar :user="user"></TopBar>
      </header>
      <expandable-player
        v-if="activeSong || (creating && createContext)"
        :song="activeSong"
      >
      </expandable-player>
      <TabBar :hidden="!showHeaderOnScreen" :selectedTab="currentTab"></TabBar>
    </div>

    <div v-else>
      <header
        class="header-global header"
        :class="{ 'navbar--hidden': !showNavbar }"
      >
        <TopBar :user="user"></TopBar>
        <div class="tabs-container">
          <TabBar :selectedTab="currentTab"></TabBar>
        </div>
      </header>
      <expandable-player v-if="activeSong || createContext" :song="activeSong">
      </expandable-player>
    </div>
  </fade-transition>
</template>
<script>
import TabBar from "@/components/TabBar";
import TopBar from "@/components/TopBar";
import ExpandablePlayer from "@/components/ExpandablePlayer";
import { PLAYER_CONTEXTS } from "@/constants";
import { FadeTransition } from "vue2-transitions";

export default {
  name: "AppHeader",
  data() {
    return {
      currentTab: this.$router.currentRoute.name,
      lastScrollPosition: 0,
      relativeScroll: 0,
      scrollDirection: "",
      windowWidth: window.innerWidth
    };
  },
  components: {
    TopBar,
    TabBar,
    ExpandablePlayer,
    FadeTransition
  },
  methods: {
    onScroll() {
      var currentPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > this.lastScrollPosition) {
        //Scroll Down
        if (this.scrollDirection !== "down") {
          this.relativeScroll = currentPosition;
          this.scrollDirection = "down";
        } else if (currentPosition - this.relativeScroll > 64) {
          this.showNavbar = false;
        }
      } else {
        //Scroll Up
        if (this.scrollDirection !== "up") {
          this.relativeScroll = currentPosition;
          this.scrollDirection = "up";
        } else if (this.relativeScroll - currentPosition > 10) {
          this.showNavbar = true;
        }
      }
      this.lastScrollPosition = currentPosition <= 0 ? 0 : currentPosition;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  watch: {
    $route(to) {
      this.currentTab = to.name;
    }
  },
  computed: {
    showNavbar: {
      get() {
        return this.$store.getters["app/getIsNavbarShowing"];
      },
      set(val) {
        this.$store.dispatch("app/setIsNavbarShowing", val);
      }
    },

    smallScreen() {
      return this.windowWidth < 1024;
    },
    showHeaderOnScreen() {
      return this.$store.getters["app/getShowHeader"];
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    activeSongId() {
      return this.$store.getters["player/getActiveSongId"];
    },
    activeSong() {
      return this.$store.getters["song/getSongById"](this.activeSongId);
    },
    createContext() {
      return this.playerContext === PLAYER_CONTEXTS.create;
    },
    playerContext() {
      return this.$store.getters["player/getContext"];
    },
    creating() {
      return this.$store.getters["creator/getCreatingMore"];
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }
};
</script>
<style scoped lang="scss">
.header {
  @media (min-width: 1024px) {
    height: 64px;
    width: 100vw;
    background-color: #09090e !important;
    position: fixed;
    transform: translate3d(0, 0, 0);
    transition: 0.15s all ease-in-out;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  z-index: 999;
}

.hidden {
  display: none;
}
.navbar--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.tabs-container {
  width: 380px;
  height: 64px;
}
</style>
